module.exports = __webpack_public_path__ + "img/4-2.6afbff25.svg";